import { isFeature } from 'Cloud/Application/FeaturesEs6';

/** B2BCLOUD-2449 Адресный доступ */
export const isPersonalAccessSharingEnabled = isFeature('personal-access-sharing') || false;
